import { useEffect, useState } from "react"
import type { ErrorFetch, SuccessFetch } from "types"
import { ProductLogList } from "../types/ProductLogList"
import { useApi } from "utils"

export function useProductLog(id: number){
    const api = useApi()
    const [dataProductLog, setProductLog] = useState<ProductLogList[] | null>(null)
    const [dataError, setError] = useState<string | undefined>(undefined)
    const [isLoading, setLoading] = useState(true)
  
    useEffect(() => {
      api.get("/product/log_product", { params: { product_id: id } })
      .then((res: SuccessFetch<{ payload: ProductLogList[] }>) => setProductLog(res.data.payload))
      .catch((err: ErrorFetch<{ detail: { message: string } }>) => setError(err.response.data.detail.message))
      .finally(() => setLoading(false))
    
      return () => {
        setProductLog(null)
        setError(undefined)
        setLoading(true)
      }
      // eslint-disable-next-line
    }, [])
  
    return { dataProductLog, dataError, isLoading }
  }